/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Card, CardContent, CardTitlePrimary } from '@design-system-coopeuch/web';
import { SvgLoader, SvgProxy } from 'react-svgmt';
import { stepperAction } from '../../../../application/actions/stepper';
import RequisitosInfo from '../RequisitosInfo';
import Botonera from '../Footer';
import { obtieneNombreApellidos } from '../../../../utils';
import iconcedula from '../../../assets/img/icon/icon-Beneficio01.svg';
import iconprevisional from '../../../assets/img/icon/icon-Beneficio03.svg';
import iconliquidacion from '../../../assets/img/icon/icon-Beneficio02.svg';
import Mastercards from '../../../assets/img/icon/Mastercards.svg';
import { properties } from '../../../../utils/properties';
import TagManagerUtils from '../../../../utils/TagManagerUtils';
import { FuturaTarjetaWrapper } from './styles';
import { verificacionActions } from '../../../../application/actions/verificacion';
import ModalEncuestaAbandono from '../../organisms/ModalEncuestaAbandono';
import ModalRespuestaEncuesta from '../../organisms/ModalRespuestaEncuesta';

const HazteSocio = () => {
  const [openModalEncuestaAbandono, setOpenModalEncuestaAbandono] = useState(false);
  const [openModalRespuestaEncuesta, setOpenModalRespuestaEncuesta] = useState(false);
  const [encuestaRespondida, setEncuestaRespondida] = useState(false); // pendiente backend

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const refMountedRequisitosInfo = useRef(false);

  const [tipoRespuesta, setTipoRespuesta] = useState('');
  const [socioEstado, setSocioEstado] = useState(false);
  const [nombreSocio, setNombreSocio] = useState('');

  const dispatch = useDispatch();
  const history = useHistory();
  const { futuratarjeta } = properties;
  const { boteneraTextos, botoneraTextoNoSocioBlack } = futuratarjeta;
  const [state, setState] = useState({
    botonera: [{ nameUno: boteneraTextos.botonDos, nameDos: boteneraTextos.botonUno }],
    botoneraNoSocio: [
      { nameUno: 'Hazte Socio', nameDos: botoneraTextoNoSocioBlack.botonUno },
    ],
    valorUF: 0,
  });

  const storeDataVerificacion = useSelector((store) => store.entities.verificacion.response);

  useEffect(() => {
    dispatch(
      verificacionActions.verificacion({
        trackId: window.localStorage.getItem('track_id')
      })
    );
    dispatch(stepperAction.fetchStepper(3));
  }, []);

  const volveraCoopeuchNoSocios = () => {
    TagManagerUtils.triggerEventMetodoThree(
      'trigger_event',
      'No socio',
      '/solicitud-tarjeta-credito/paso3/hazte-socio-cuenta-vista',
      'Click',
      'Hazte Socio + Cuenta Vista'
    );
    window.location.href = properties.urlNoSocios;
  };

  useEffect(() => {
    if ('code' in storeDataVerificacion && storeDataVerificacion.code === -1) {
      window.localStorage.setItem('paso', '/tu-futura-tarjeta/mastercard/gold');
      history.push('/error-conexion');
    }
    if (storeDataVerificacion.length !== 0 && storeDataVerificacion.data) {
      const { socio, nombres, primerApellido, segundoApelllido } = storeDataVerificacion.data;
      setSocioEstado(socio);
      setNombreSocio(obtieneNombreApellidos(nombres, primerApellido, segundoApelllido));
      if (!socio) {
        TagManagerUtils.vpvMetodo(
          'vpv',
          '/solicitud-tarjeta-credito/paso3/hazte-socio-cuenta-vista',
          'No socio'
        );
      }
    }
  }, [storeDataVerificacion]);

  const volverACoopeuch = () => {
    window.location.href = properties.urlCoopeuch;
  };

  const retomarEncuesta = () => {
    setOpenModalEncuestaAbandono(true);
    setOpenModalRespuestaEncuesta(false);
  };

  const { botonera, botoneraNoSocio, valorUF } = state;

  return (
    <>
      <FuturaTarjetaWrapper>
        <div className="futura-tarjeta-header-gold">
          <div className="t-internacional texto-tarifas">
            <p className="titulo">{properties.futuratarjeta.hazteSocioTitulo}</p>
            <p className="subtitulo">{properties.futuratarjeta.hazteSocioBajada}</p>
          </div>
          <div className="t-internacional">
            <SvgLoader path={Mastercards}>
              <SvgProxy selector=".nombreNoSocio">{nombreSocio}</SvgProxy>
            </SvgLoader>
          </div>
        </div>
        <div className="card">
          <Card className="Card-Class">
            <CardTitlePrimary title={properties.futuratarjeta.hazteSocioBeneficios} />
            <CardContent>
              <div className="contenedor-gold-card">
                <div className="info">
                  <img className="iconcedula" src={iconcedula} alt="cedula" />
                  <p className="p-mensaje">{properties.futuratarjeta.BeneficiosGold.titulo}</p>
                  <p className="p-coment">{properties.futuratarjeta.BeneficiosGold.bajada}</p>
                </div>
                <div className="info">
                  <img className="iconliquidacion" src={iconliquidacion} alt="liquidacion" />
                  <p className="p-mensaje">{properties.futuratarjeta.BeneficiosGold.tituloDos}</p>
                  <p className="p-coment">{properties.futuratarjeta.BeneficiosGold.bajadaDos}</p>
                </div>
                <div className="info">
                  <img className="iconprevision" src={iconprevisional} alt="prevision" />
                  <p className="p-mensaje">{properties.futuratarjeta.BeneficiosGold.tituloTres}</p>
                  <p className="p-coment">{properties.futuratarjeta.BeneficiosGold.bajadaTres}</p>
                </div>
              </div>
            </CardContent>
          </Card>
          <RequisitosInfo requisitosRef={refMountedRequisitosInfo} />
        </div>
        <Botonera
          tituloboton={socioEstado ? botonera : botoneraNoSocio}
          verificarFunction={volveraCoopeuchNoSocios}
          volverHome={
            process.env.REACT_APP_HABILITAR_ENCUESTAS === 'true'
              ? setOpenModalEncuestaAbandono
              : volverACoopeuch
          }
          estadoBotonUno
          estadoBotonDos={false}
          nombreDinamicoResponsive={false}
        />
        {openModalEncuestaAbandono && (
          <ModalEncuestaAbandono
            setTipoRespuesta={setTipoRespuesta}
            setOpenModalEncuestaAbandono={setOpenModalEncuestaAbandono}
            setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
            setEncuestaRespondida={setEncuestaRespondida}
          />
        )}
        {openModalRespuestaEncuesta && (
          <ModalRespuestaEncuesta
            tipoRespuesta={tipoRespuesta}
            setOpenModalRespuestaEncuesta={setOpenModalRespuestaEncuesta}
            titulo={
              tipoRespuesta === 'exito'
                ? properties.encuestaAbandono.exitoTitulo
                : properties.encuestaAbandono.errorTitulo
            }
            descripcion={
              tipoRespuesta === 'exito'
                ? properties.encuestaAbandono.exitoDescripcion
                : properties.encuestaAbandono.errorDescripcion
            }
            botonAccion={tipoRespuesta === 'exito' ? volverACoopeuch : retomarEncuesta}
            botonTexto={
              tipoRespuesta === 'exito'
                ? properties.encuestaAbandono.exitoBoton
                : properties.encuestaAbandono.errorBoton
            }
          />
        )}
      </FuturaTarjetaWrapper>
    </>
  );
};

export default HazteSocio;
